export default __webpack_public_path__ + "static/media/Statistics_2006.87a73427.zip";